import { X } from 'lucide-react';
import { Dialog as Primitive } from 'radix-ui';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils.ts';

/**
 * shadcn/ui Sheet (a side panel), vendored on the Dialog primitive. Used for the candidate
 * side panel (RELAY-944): it overlays the table instead of replacing it, which is what keeps
 * the table's scroll position.
 */
export const Sheet = Primitive.Root;
export const SheetTrigger = Primitive.Trigger;
export const SheetClose = Primitive.Close;
export const SheetTitle = Primitive.Title;
export const SheetDescription = Primitive.Description;

export function SheetContent({
  className,
  children,
  side = 'right',
  ...props
}: ComponentProps<typeof Primitive.Content> & { side?: 'right' | 'left' }) {
  return (
    <Primitive.Portal>
      <Primitive.Overlay className="animate-fade-in fixed inset-0 z-50 bg-black/40 dark:bg-black/60" />
      <Primitive.Content
        className={cn(
          'bg-card border-border shadow-raised fixed inset-y-0 z-50 flex w-full max-w-2xl flex-col gap-4 overflow-y-auto border-l p-6',
          side === 'right' ? 'right-0' : 'left-0 border-r border-l-0',
          className,
        )}
        {...props}
      >
        {children}
        <Primitive.Close className="focus:ring-ring absolute top-4 right-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:outline-none">
          <X className="size-4" />
          <span className="sr-only">Close</span>
        </Primitive.Close>
      </Primitive.Content>
    </Primitive.Portal>
  );
}
